import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Brand } from "@/components/Brand";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          toast.success("Subscription active — thank you!");
          setTimeout(() => nav("/app/billing"), 1800);
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (e) { /* keep polling */ }
      if (tries >= 8) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [nav]);

  return (
    <div className="min-h-screen grid place-items-center px-6">
      <div className="text-center max-w-sm">
        <Brand className="mb-8 justify-center" />
        {status === "checking" && (<><Loader2 className="h-8 w-8 animate-spin text-accent mx-auto" /><p className="mt-4 text-muted-foreground">Confirming your payment…</p></>)}
        {status === "paid" && (<><CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" /><h1 className="text-2xl font-bold mt-4">Payment confirmed</h1><p className="text-muted-foreground mt-2">Taking you to your billing…</p></>)}
        {(status === "error" || status === "timeout") && (<><h1 className="text-2xl font-bold">Hmm, still processing</h1><p className="text-muted-foreground mt-2">Your payment may still be confirming. Check your billing page shortly.</p><button onClick={() => nav("/app/billing")} className="mt-6 px-5 py-2.5 bg-primary text-primary-foreground font-medium">Go to billing</button></>)}
      </div>
    </div>
  );
}
